import { NAVIGATION_DRAWER_ACTIVATE, NAVIGATION_DRAWER_DEACTIVATE } from "./action";

interface State {
    willShowNavigationDrawer: boolean;
};

const initialState: State = {
    willShowNavigationDrawer: false,
}

type Actions = NAVIGATION_DRAWER_ACTIVATE | NAVIGATION_DRAWER_DEACTIVATE;

const Reducer = (state: State = initialState, action: Actions) => {
    switch(action.type) {
        case "NAVIGATION_DRAWER_ACTIVATE": {
            document.body.style.overflow = "hidden";
            state.willShowNavigationDrawer = true;
            return state;
        }
        case "NAVIGATION_DRAWER_DEACTIVATE": {
            document.body.style.overflow = "";
            state.willShowNavigationDrawer = false;
            return state;
        }
        default:
            return state;
    }
};


export default Reducer;